import { render } from "./OvNotesModal.vue?vue&type=template&id=8419773a&scoped=true"
import script from "./OvNotesModal.vue?vue&type=script&lang=js"
export * from "./OvNotesModal.vue?vue&type=script&lang=js"

import "./OvNotesModal.vue?vue&type=style&index=0&id=8419773a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8419773a"],['__file',"src/components/OvNotesModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8419773a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8419773a', __exports__)) {
    api.reload('8419773a', __exports__)
  }
  
  module.hot.accept("./OvNotesModal.vue?vue&type=template&id=8419773a&scoped=true", () => {
    api.rerender('8419773a', render)
  })

}


export default __exports__